<div class="container-fluid non-transparent-header px-0">
    <div class="row mx-auto">
        <div class="author text-center w-100 vmb-2 q-page-header only-desktop" *ngIf="isDesktop">
            <ng-container>
                <h1 class="card-title q-page-header-title">Shipping Policy</h1>
                <span class="w-200px underline-text-dark"></span>
            </ng-container>
        </div>
        <div class="form-row row mx-auto vpb-2" [class.w-80]="isDesktop">
            <div class="sqs-block-content">
                <p  class="white-space">
                    Qatch is a product discovery platform that works for hundreds of brands to help you find products from them that you will love.
                </p>
                <p  class="white-space">
                    Qatch is not responsible for, and does not facilitate, manage, or control the transaction or shipping details of products purchased from a Qatch recommendation.
                    All transactions and shipping details are fulfilled by the brand you are purchasing from, so <a class="text-grey">please be sure to review their shipping and return policies carefully</a>.
                </p>
                <p  class="white-space">Qatch is not responsible for any issues related to customs and duty tax, issues relating to shipment and delays, issues related to delivery, packaging or returns of products recommended by Qatch on behalf of our brand partners. 
                    For all inquiries and concerns regarding quality assurances, delays, returns, product defects, or any other concerns, please reach out to the brand directly.</p>
                <p  class="white-space">For more information, please contact us at:<a class="text-danger shipping_policy_support"  href="mailto:sendhelp@joinqatch.com">sendhelp&#64;joinqatch.com</a>,
                    or write to us at: 25 Dorchester Ave. #52264 Boston, MA 02205.</p>
            </div>
        </div>
    </div>
</div>